import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import TestimonialGrid from '@/components/testimonials/TestimonialGrid';
import ResultsSection from '@/components/ResultsSection';
import CaseStudiesSection from '@/components/CaseStudiesSection';
import CalendlySection from '@/components/CalendlySection';

export default function CaseStudies() {
  useEffect(() => {
    document.title = 'Client Testimonials & Case Studies — Ahana Digital Agency';
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Navbar />
      <section className="pt-32 lg:pt-40 pb-6">
        <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Clients & Results</p>
          <h1 className="mt-4 font-display font-bold text-white tracking-tight leading-[1.05] text-4xl lg:text-6xl max-w-4xl">
            In our clients’ words — and in their numbers.
          </h1>
          <p className="mt-6 text-white/55 font-light leading-relaxed max-w-2xl">
            Testimonials and case studies from brands across luxury, automotive, beauty, hospitality and B2B growth.
          </p>
        </div>
      </section>
      <TestimonialGrid />
      <ResultsSection />
      <CaseStudiesSection />
      <CalendlySection />
      <Footer />
    </div>
  );
}